import gql from 'graphql-tag';

export default gql`
    mutation UpdateBox($input: UpdateBoxInput) {
        updateBox(input: $input) {
            errors
        }
    }
`;
